import { type AxiosError } from 'axios'
import { type FC, type ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'

import { Notification } from 'base-ui'

import { VALIDATION_ERROR_FRIENDLY_CAPTCHA_FAILED } from '../../../base-form-handling'
import { HTTP_STATUS_CODE_BAD_REQUEST } from '../../../http'
import { type UserLoginResponseError } from '../../api/swr/useUserApiLoginMutation'

const getErrorMessage = (
  error: AxiosError<UserLoginResponseError>,
): ReactElement => {
  if (
    error.response?.status === HTTP_STATUS_CODE_BAD_REQUEST &&
    error.response.data.error === VALIDATION_ERROR_FRIENDLY_CAPTCHA_FAILED
  ) {
    return <FormattedMessage id="changeEmail.errorMessage.general" />
  }

  if (error.response?.status === HTTP_STATUS_CODE_BAD_REQUEST) {
    return <FormattedMessage id="login.error.badinput" />
  }

  return <FormattedMessage id="changeEmail.errorMessage.general" />
}

export const LoginRegistrationUserLoginGeneralError: FC<{
  className?: string
  error: AxiosError<UserLoginResponseError> | undefined
}> = ({ className, error }) => {
  if (!error) {
    return null
  }

  return (
    <div className={className}>
      <Notification icon severity="error">
        {getErrorMessage(error)}
      </Notification>
    </div>
  )
}
